<template>
  <div class="page-container">
    <!-- 顶部功能区 -->
      <!-- 标题和图标 -->
      <div class="header animate-fade-in">
        <svg id="_图层_1" data-name="图层 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 510.24 510.24" class="logo-icon">
          <rect class="cls-2" width="510.24" height="510.24" rx="93.3" ry="93.3"/>
          <path class="cls-1" d="M426.84,234.48c2.01,1.57,1.92,8.68,1.93,13.86-.17,12.08.36,27.88-.27,39.84-.3,6.34-4.59,6.61-9.81,6.66-7.14.07-14.64.01-21.89.03-3.02,0-5.97,0-8.69,0-9.46.06-16.15-.22-22.49.9-2.69.51-5.35,1.4-7.69,3.03-8.44,5.4-7.66,19.27,1.76,22.69,8.12,3.05,16.03,2.27,24.81,2.52,12.39.04,31.03-.06,41.06.04,4.41.08,8.83.13,8.87,6.5.43,15.13.04,46.57.15,62.71-.09,4.75.4,10.71-5.14,10.76-13.99.65-36.36,0-51.8.22-9.86.03-19.22,0-29.42-.97-44.33-3.38-81.61-26.34-84.37-79.92-.92-29.8-.1-69.47-.37-98.7-1.06-35.5,4.57-65.33,32.02-85.01,32.73-22.79,74.45-15.93,112.78-17.04,10.59.33,16.46-.68,23.23.58,4.38.84,2.74,11.54,3.08,17.27,0,13.91,0,36.18,0,50.29-.04,7.68.36,12.65-6.37,12.75-10.78.44-22.4.08-33.22.19-11.55.24-18.49-.85-28.15,2.55-10.25,3.43-13.41,15.18-3.82,21.9,4.08,2.73,8.83,3.49,13.6,3.88,8.41.61,22.16.32,32.66.39,4.95.22,14.72-.86,17.46,2.02l.08.09Z"/>
          <rect class="cls-1" x="78.78" y="124.4" width="177.23" height="56.69" rx="25.51" ry="25.51"/>
          <rect class="cls-1" x="130.32" y="198.14" width="95.43" height="56.69" rx="25.51" ry="25.51"/>
          <rect class="cls-1" x="100.92" y="271.88" width="95.43" height="56.69" rx="25.51" ry="25.51"/>
          <rect class="cls-1" x="78.78" y="344.83" width="177.23" height="56.69" rx="25.51" ry="25.51"/>
        </svg>
        <h1 class="title">ZError题库</h1>
      </div>

      <!-- 搜索框 -->
      <div class="search-wrapper animate-fade-in animate-delay-1">
        <div class="search-container">
          <input 
            v-model="searchQuery" 
            type="text" 
            placeholder="请输入搜索内容..." 
            class="search-input"
            @keyup.enter="handleSearch"
          />
          <button class="search-btn" @click="handleSearch">
            <span class="search-icon">🔍</span>
          </button>
        </div>
      </div>

      <!-- 切换按钮 -->
      <PlatformSwitch v-model="selectedOption" class="animate-fade-in animate-delay-2"/>
    </div>

    <div class="icp-info">
    <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
      津ICP备2024025272号-2
    </a>
  </div>

</template>

<script>
import PlatformSwitch from '@/components/PlatformSwitch.vue';

export default {
  components: {
    PlatformSwitch
  },
  data() {
    return {
      searchQuery: '',
      selectedOption: '题目', // 修改默认选项为"题目"
      stopFloatingImage: null // 存储停止函数的引用
    };
  },
  methods: {
    handleSearch() {
      if (this.searchQuery.trim()) {
        // 确保 stopFloatingImage 存在再调用
        
        
        
        // 添加时间戳确保每次搜索都会触发路由变化
        this.$router.push(`/search?q=${encodeURIComponent(this.searchQuery)}&type=${encodeURIComponent(this.selectedOption)}&_t=${Date.now()}`);
      }
    }
  },

  mounted() {
    // 保存停止函数的引用

  },

};
</script>

<style scoped>
.page-container {
  display: flex;
  flex-direction: column;
  height: 70vh;
  align-items: center; /* 使整个容器内容居中 */
  justify-content: center; /* 垂直居中 */

}

.header {
  display: flex;
  align-items: center;
  justify-content: center; /* 使标题和图标居中 */
  margin-bottom: 30px; /* 增加间距 */
  width: 100%;
  animation: 2s ease-in-out infinite;
}



.logo-icon {
  width: 48px; /* 放大图标 */
  height: 48px; /* 放大图标 */
  margin-right: 15px; /* 增加间距 */
}

/* 修复SVG图标样式 */
.logo-icon .cls-1 {
  fill: #ffffff; /* 白色填充 */
}

.logo-icon .cls-2 {
  fill: #F8B62D; 
}

.title {
  font-size: 42px;
  font-weight: bold;
  margin: 0;
  background: linear-gradient(45deg, #F8B62D, #F2756F);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  
}

.search-wrapper {
  margin-bottom: 30px; /* 增加间距 */
  width: 100%;
  max-width: 600px; /* 放大搜索框 */
  transition: max-width 0.3s ease; /* 添加平滑过渡 */
}

.search-wrapper:focus-within {
  max-width: 700px; /* 选中时增加100px */
}

.search-container {
  display: flex;
  width: 100%;
  margin: 0 auto;
  border-radius: 30px; /* 增加圆角 */
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1); /* 增强阴影 */
  border: 1px solid #e8e8e8;
  transition: 0.3s
}

.search-input {
  flex: 1;
  padding: 16px 24px; /* 增加内边距 */
  border: none;
  font-size: 18px; /* 放大字体 */
  outline: none;
}

.search-btn {
  background-color: transparent; /* 移除蓝色背景 */
  color: #666; /* 改变图标颜色 */
  border: none;
  padding: 0 24px;
  cursor: pointer;
}

.search-btn:hover {
  color: #1890ff; /* 悬停时变蓝 */
  background-color: transparent; /* 确保悬停时也没有背景色 */
}

.search-icon {
  font-size: 24px; /* 放大搜索图标 */
}

@media screen and (max-width: 768px) {
  .page-container{
    height: 70vh;
  }

  .search-container{
    max-width: 90%;
  }

  .search-input{
    padding-right: 0px;
    padding-left: 24px;
  }
  .search-icon{
    padding-right: 0px;
  }

}

/* 添加动画相关样式 */
.animate-fade-in {
  opacity: 0;
  transform: translateY(20px);
  animation: fadeInUp 0.6s ease forwards;
}

.animate-delay-1 {
  animation-delay: 0.2s;
}

.animate-delay-2 {
  animation-delay: 0.4s;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.icp-info {
  position: fixed;
  bottom: 20px;
  left: 0;
  width: 100%;
  text-align: center;
  padding: 10px;
  font-size: 14px;
  color: #666;
}

.icp-info a {
  color: #666;
  text-decoration: none;
  transition: color 0.3s ease;
}

.icp-info a:hover {
  color: #F8B62D;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .icp-info {
    bottom: 10px;
    font-size: 12px;
  }
}
</style>
